import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "pop";
var userDataSidas = localStorage.getItem("userDataSidas") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas")))) : "";
var popService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataSidas["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataSidas["firmaKodu"] + "/kucuk/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataSidas["firmaKodu"] + "/enkucuk/",
    popTanimlama(baslik, icerik, resim, resimBase, link, otomatik, baslamaTarihi, bitisTarihi, gorunum, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                baslik: baslik,
                icerik: icerik,
                resim: resim,
                resimBase: resimBase,
                link: link,
                otomatik: otomatik,
                baslamaTarihi: baslamaTarihi,
                bitisTarihi: bitisTarihi,
                gorunum: gorunum,
                durum: durum,
                dil: [],
                methodName: "popTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    },
    popGuncelDetay() {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                firmaKodu: userDataSidas["firmaKodu"],
                methodName: "detay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    popListDetay(baslangic, limit, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                baslangic: baslangic,
                limit: limit,
                durum: durum,
                dil: "",
                methodName: "listDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    popDurumGuncelle(popKodu, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                popKodu: popKodu,
                durum: durum,
                methodName: "durumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }, popDetay(popKodu) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                popKodu: popKodu,
                dil: '',
                methodName: "detay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    popGuncelle(popKodu, updateList) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                popKodu: popKodu,
                updateList: updateList,
                methodName: "guncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
}

export default popService

